'use strict';

const $ = jQuery.noConflict();
$(function() {

	$('.js-media-listing').each(function() {

		const $wrapper = $(this);

		const listing = {

			$loader: null,
			$noResults: null,
			listingType: '',
			pagingKey: '',
			itemsPerPage: 12,
			artistId: 0,
			contributorId: 0,
			ids: [],
			siteSection: '',
			filterTaxType: '',
			hideAlbumSongs: false,
			skipFilterWomen: false,

			init() {
				this.$loader = $wrapper.find('.js-filters-loader');
				this.$noResults = $wrapper.find('.js-filters-no-results');
				this.listingType = $wrapper.data('listing-type') || '';
				this.pagingKey = $wrapper.data('paging-key') || this.listingType;
				this.itemsPerPage = parseInt($wrapper.data('items-per-page')) || 12;
				this.artistId = parseInt($wrapper.data('artist-id')) || 0;
				this.contributorId = parseInt($wrapper.data('contributor-id')) || 0;
				this.ids = String($wrapper.data('ids') || '').split(',').filter(item => item !== '');
				this.siteSection = $wrapper.data('site-section') || '';
				this.filterTaxType = $wrapper.data('filter-tax-type') || '';
				this.hideAlbumSongs = parseInt($wrapper.data('hide-album-songs')) === 1;
				this.skipFilterWomen = parseInt($wrapper.data('skip-filter-women')) === 1;

				$wrapper.on('click', '.pagination__link', (e) => this.onPaginationClick(e));
				$wrapper.on('change', '.js-filter-select', () => this.onFilterChange());
				$wrapper.on('change', '.js-sort-select', () => this.onFilterChange());
				$wrapper.on('click', '.js-filter-chip', () => {
					setTimeout(() => this.onFilterChange(), 0);
				});
			},

			onPaginationClick(event) {
				event.preventDefault();

				const $link = $(event.currentTarget);

				if ($link.hasClass('pagination__link--current') || $link.closest('.pagination__item--dots').length) {
					return;
				}

				this.fetchPage(parseInt($link.data('page')) || 1, true, true);
			},

			onFilterChange() {
				this.fetchPage(1, false, true);
			},

			fetchPage(page, scrollOnLoad, pushHistory) {
				const itemCount = $wrapper.find('.js-media-listing-items .media-listing__item').length;
				if (scrollOnLoad && itemCount >= 5) {
					$('html, body').animate({
						scrollTop: $wrapper.offset().top - 100,
					}, 400);
				}

				this.setLoading(true);

				const baseData = {
					'action': 'fws-media-listing',
					'listing_type': this.listingType,
					'paging_key': this.pagingKey,
					'current_url': window.location.pathname + window.location.search,
					'page': page,
					'items_per_page': this.itemsPerPage,
					'ids': this.ids,
				};
				if (this.artistId) {
					baseData['artist_id'] = this.artistId;
				}
				if (this.contributorId) {
					baseData['contributor_id'] = this.contributorId;
				}
				if (this.siteSection) {
					baseData['site_section'] = this.siteSection;
				}
				if (this.filterTaxType) {
					baseData['filter_tax_type'] = this.filterTaxType;
				}
				if (this.hideAlbumSongs) {
					baseData['hide_album_songs'] = 1;
				}
				if (this.skipFilterWomen) {
					baseData['skip_filter_women'] = 1;
				}

				const filters = this.getFilters();

				$.ajax({
					method: 'POST',
					url: window.fwsLocalized.ajaxUrl,
					data: $.extend(baseData, filters),
					success: (response) => this.onSuccess(response, pushHistory, filters),
					error: (jqXHR, textStatus, errorThrown) => this.onError(jqXHR, textStatus, errorThrown),
					complete: () => this.onComplete(),
				});
			},

			updateUrl(page, filters, pushHistory) {
				const url = new URL(window.location.href);

				const syncListParam = (suffix, values) => {
					const key = `${this.pagingKey}_${suffix}`;
					if (values && values.length) {
						const sortedValues = values.map(String).sort();
						url.searchParams.set(key, sortedValues.join(','));
					} else {
						url.searchParams.delete(key);
					}
				};

				if (page <= 1) {
					url.searchParams.delete(`${this.pagingKey}_page`);
				} else {
					url.searchParams.set(`${this.pagingKey}_page`, page);
				}

				syncListParam('topic', filters.topic);
				syncListParam('type', filters.type);
				syncListParam('tag', filters.tag);
				syncListParam('sort', filters.sort ? [filters.sort] : []);

				const sortedEntries = [...url.searchParams.entries()].sort(([a], [b]) => a.localeCompare(b));
				url.search = new URLSearchParams(sortedEntries).toString();

				const method = pushHistory ? 'pushState' : 'replaceState';
				window.history[method]({}, '', url.pathname + url.search + url.hash);
			},

			getFilters() {
				const filters = {};

				$wrapper.find('.js-filter-dropdown').each(function() {
					const group = $(this).data('filter-group');
					const values = $(this).find('.js-filter-select').val() || [];
					if (values.length) {
						filters[group] = values;
					}
				});

				const activeTags = [];
				$wrapper.find('.js-filter-chip.is-active').each(function() {
					activeTags.push($(this).data('filter-value'));
				});
				if (activeTags.length) {
					filters['tag'] = activeTags;
				}

				const $sortSelect = $wrapper.find('.js-sort-select');
				const sort = $sortSelect.val();
				const defaultSort = $sortSelect.data('default-sort') || '';
				// the default sort order is redundant to send/persist since the server
				// treats a missing sort value the same way.
				if (sort && sort !== defaultSort) {
					filters['sort'] = sort;
				}

				return filters;
			},

			onSuccess(response, pushHistory, filters) {
				if (!response.success || !response.data) {
					return;
				}

				const data = response.data;
				const hasResults = data.html.trim().length > 0;

				$wrapper.find('.js-media-listing-items').html(data.html);
				this.$noResults.toggleClass('is-visible', !hasResults);

				const $footer = $wrapper.find('.js-media-listing-pagination');
				if (data.pagination) {
					$footer.html(data.pagination).show();
				} else {
					$footer.empty().hide();
				}

				this.updateUrl(data.page, filters, pushHistory);

				// trigger custom event
				$(document).trigger('media-listing:updated', {
					data: data,
					container: $wrapper
				});
			},

			onError(jqXHR, textStatus, errorThrown) {
				console.error('AJAX error: ' + textStatus + ' - ' + errorThrown);
			},

			onComplete() {
				this.setLoading(false);
			},

			setLoading(state) {
				this.$loader.toggleClass('is-visible', state);
				$wrapper.find('.js-media-listing-items, .js-media-listing-pagination').toggle(!state);
				if (state) {
					this.$noResults.removeClass('is-visible');
				}
			},

		};

		listing.init();
	});

	// Pagination/filter state is pushed to the URL via pushState/replaceState, but the
	// listing markup (items, pagination, filter selections) is never updated in place
	// on browser back/forward — reload so the server re-renders the state for the URL.
	window.addEventListener('popstate', () => {
		window.location.reload();
	});

});
